module.exports = __webpack_public_path__ + "static/media/Laptop Categorie.663f833c.png";